export function constructLink (linkSlug) {
  const theme = new URLSearchParams({ theme: linkSlug })

  return '/search?' + theme
}
